import { makeStyles } from '@material-ui/core/styles';

const PILL_RADIUS = 999;

export default makeStyles((theme) => ({
  control: {
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginRight: theme.spacing(3),
    // The tag repeats what the menu already says; narrow bars keep the button only.
    [`@media (max-width: ${theme.screens.small_desktop}px)`]: {
      '& > :first-child': { display: 'none' }
    }
  },
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minHeight: 32,
    padding: theme.spacing(1, 1, 1, 3),
    border: `1px solid ${theme.colorPalette.beige_60}`,
    borderRadius: PILL_RADIUS,
    background: theme.colorPalette.beige_40,
    color: theme.colorPalette.green_100,
    font: 'inherit',
    fontSize: 13,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:focus-visible': { outline: `2px solid ${theme.colorPalette.green_75}`, outlineOffset: 2 }
  },
  triggerLabel: {
    fontWeight: 400,
    color: theme.colorPalette.green_90
  },
  menu: {
    width: 320,
    padding: theme.spacing(4),
    borderRadius: theme.sizes.innerCorners,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  segments: {
    display: 'flex',
    padding: 3,
    gap: 2,
    marginBottom: theme.spacing(2),
    borderRadius: PILL_RADIUS,
    border: `1px solid ${theme.colorPalette.beige_60}`,
    background: theme.colorPalette.beige_40
  },
  segment: {
    flex: 1,
    minHeight: 32,
    padding: theme.spacing(1.5, 3),
    border: 0,
    borderRadius: PILL_RADIUS,
    background: 'none',
    color: theme.colorPalette.green_100,
    font: 'inherit',
    fontSize: 13,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:disabled': { color: theme.colorPalette.beige_90, cursor: 'not-allowed' },
    '&:focus-visible': { outline: `2px solid ${theme.colorPalette.green_75}`, outlineOffset: 2 }
  },
  segmentSelected: {
    background: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    fontWeight: 700
  },
  subjectFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  hint: {
    display: 'block'
  }
}));
